import { MutationFunction, MutationOptions, useMutation } from 'react-query';
import {
    MarkAsAbsentReportBody,
    MarkAsAbsentsReportsBody,
    ReportResponse,
    UpdateReportBody,
    createOrUpdateAbsentReport,
    createOrUpdateAbsentsReports,
    updateReport,
} from '../../services/apiSLTP/dailyReports/reports';

type UseUpdateReportMutationOptions = MutationOptions<ReportResponse, Error, { id: string; body: UpdateReportBody }>;

export const useUpdateReportMutation = (options?: UseUpdateReportMutationOptions) => {
    const updateMutation: MutationFunction<ReportResponse, { id: string; body: UpdateReportBody }> = async ({ id, body }) => {
        try {
            return await updateReport(id, body);
        } catch (error) {
            throw new Error('An unexpected error occurred while updating the report');
        }
    };

    return useMutation(updateMutation, options);
};

type UseCreateOrUpdateAbsentReportMutationOptions = MutationOptions<ReportResponse, Error, { body: MarkAsAbsentReportBody }>;

export const useCreateOrUpdateAbsentReportMutation = (options?: UseCreateOrUpdateAbsentReportMutationOptions) => {
    const absentMutation: MutationFunction<ReportResponse, { body: MarkAsAbsentReportBody }> = async ({ body }) => {
        try {
            return await createOrUpdateAbsentReport(body);
        } catch (error) {
            throw new Error('An unexpected error occurred while creating or updating the absent report');
        }
    };

    return useMutation(absentMutation, options);
};

type UseCreateOrUpdateAbsentsReportsMutationOptions = MutationOptions<ReportResponse, Error, { body: MarkAsAbsentsReportsBody }>;

export const useCreateOrUpdateAbsentsReportsMutation = (options?: UseCreateOrUpdateAbsentsReportsMutationOptions) => {
    const absentMutation: MutationFunction<ReportResponse, { body: MarkAsAbsentsReportsBody }> = async ({ body }) => {
        try {
            return await createOrUpdateAbsentsReports(body);
        } catch (error) {
            throw new Error('An unexpected error occurred while creating or updating the absent report');
        }
    };

    return useMutation(absentMutation, options);
};
